import { GetLoanApplicationResponse } from 'api/typegen/client/application/get';
import fetchWebApi from 'api/fetchWebApi';

const getLoanApplicationApiCall =
  async (): Promise<GetLoanApplicationResponse> =>
    fetchWebApi('/client/application');

export default getLoanApplicationApiCall;
